export default __webpack_public_path__ + "static/media/trip-imagem.c023a635.svg";